import { render, staticRenderFns } from "./Administrador.vue?vue&type=template&id=7eb38008&scoped=true&"
import script from "./Administrador.vue?vue&type=script&lang=js&"
export * from "./Administrador.vue?vue&type=script&lang=js&"
import style0 from "./Administrador.vue?vue&type=style&index=0&id=7eb38008&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb38008",
  null
  
)

export default component.exports